import { useQuery } from "@tanstack/react-query"
import { goalQuery } from "modules/campaigns/lib/goals/goalQuery"

export function useGoalQuery(...args: Parameters<typeof goalQuery>) {
  return useQuery(goalQuery(...args))
}
